// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbookActivityEventsQueryVariables = Types.Exact<{
  workbookId: Types.Scalars["ID"]["input"];
}>;

export type WorkbookActivityEventsQuery = {
  __typename?: "GraphqlQuery";
  getWorkbookDetails: {
    __typename?: "Workbook";
    id: string;
    activity: Array<{
      __typename?: "WorkbookActivity";
      id: string;
      createdAt: number;
      eventType: string;
      description: string;
      user?: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
        avatarUrl?: string | null;
      } | null;
    }>;
  };
};

export const WorkbookActivityEventsDocument = gql`
  query WorkbookActivityEvents($workbookId: ID!) {
    getWorkbookDetails(workbookId: $workbookId) {
      id
      activity {
        id
        createdAt
        eventType
        description
        user {
          id
          fullname
          avatarUrl
        }
      }
    }
  }
`;

/**
 * __useWorkbookActivityEventsQuery__
 *
 * To run a query within a React component, call `useWorkbookActivityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbookActivityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbookActivityEventsQuery({
 *   variables: {
 *      workbookId: // value for 'workbookId'
 *   },
 * });
 */
export function useWorkbookActivityEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbookActivityEventsQuery,
    WorkbookActivityEventsQueryVariables
  > &
    (
      | { variables: WorkbookActivityEventsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorkbookActivityEventsQuery,
    WorkbookActivityEventsQueryVariables
  >(WorkbookActivityEventsDocument, options);
}
export function useWorkbookActivityEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbookActivityEventsQuery,
    WorkbookActivityEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkbookActivityEventsQuery,
    WorkbookActivityEventsQueryVariables
  >(WorkbookActivityEventsDocument, options);
}
// @ts-ignore
export function useWorkbookActivityEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbookActivityEventsQuery,
    WorkbookActivityEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkbookActivityEventsQuery,
  WorkbookActivityEventsQueryVariables
>;
export function useWorkbookActivityEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookActivityEventsQuery,
        WorkbookActivityEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkbookActivityEventsQuery | undefined,
  WorkbookActivityEventsQueryVariables
>;
export function useWorkbookActivityEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookActivityEventsQuery,
        WorkbookActivityEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkbookActivityEventsQuery,
    WorkbookActivityEventsQueryVariables
  >(WorkbookActivityEventsDocument, options);
}
export type WorkbookActivityEventsQueryHookResult = ReturnType<
  typeof useWorkbookActivityEventsQuery
>;
export type WorkbookActivityEventsLazyQueryHookResult = ReturnType<
  typeof useWorkbookActivityEventsLazyQuery
>;
export type WorkbookActivityEventsSuspenseQueryHookResult = ReturnType<
  typeof useWorkbookActivityEventsSuspenseQuery
>;
export type WorkbookActivityEventsQueryResult = Apollo.QueryResult<
  WorkbookActivityEventsQuery,
  WorkbookActivityEventsQueryVariables
>;
